const t = "adyen-pe-overview-details", n = `${t}__skeleton`, e = `${n}-container`, o = `${n}--loading-content`, S = `${t}__status-skeleton`;
export {
  t as BASE_CLASS,
  n as SKELETON_CLASS,
  e as SKELETON_CONTAINER,
  o as SKELETON_LOADING,
  S as STATUS_SKELETON
};
